import { Breakpoint } from '@/shared/models/breakpoint-type'

class BreakpointService {
    /** 
     * currentBreakpoint: returns the currentBreakpoint based on the screenwidth
     * in the _site.scss stylesheet the content of the :before pseudo-element on the body 
     * is filled with the name of the current breakpoint
     */
    get currentBreakpoint(): Breakpoint {
        let breakpoint = window.getComputedStyle(document.body, ':before').content.replace(/"/g, '')

        switch (breakpoint) {
            case 'small':
                return Breakpoint.Mobile
            case 'medium':
                return Breakpoint.TabletPortrait
            case 'large':
                return Breakpoint.TabletLandscape
            default:
                return Breakpoint.Desktop
        }
    }
}

export default new BreakpointService()